export const blockIconsUiactionsSettingsNew = (
	<span className='material-symbols-outlined'>settings</span>
);
